import type { Module } from 'vuex';
import { LanguageEntity } from '@/types/LanguageEntity';
import {RootState} from "@/store";

export interface LanguageEntitiesState {
  languageEntities: LanguageEntity[];
}

const languageEntitiesModule: Module<LanguageEntitiesState, RootState> = {
  namespaced: true,

  state: (): LanguageEntitiesState => ({
    languageEntities: [],
  }),

  getters: {
    getById: (state) => (idLanguageEntity: number): LanguageEntity | undefined => {
      return state.languageEntities.find(languageEntity => languageEntity.idLanguageEntity === idLanguageEntity);
    },
  },

  mutations: {
    setLanguageEntities(
      state,
      payload: { languageEntities: Record<number, any> }
    ) {
      state.languageEntities = Object
        .values(payload.languageEntities)
        .map(raw => LanguageEntity.fromRaw(raw));
    },

    setLanguageEntityCreate(
      state,
      payload: {
        idLanguageEntity: number;
        name: string;
      }
    ) {
      const languageEntity = new LanguageEntity(
        payload.idLanguageEntity,
        payload.name,
        false,
      );
      state.languageEntities.push(languageEntity);
    },

    setLanguageEntityDelete(
      state,
      payload: { idLanguageEntity: number }
    ) {
      state.languageEntities = state.languageEntities.filter(
        languageEntity => languageEntity.idLanguageEntity !== payload.idLanguageEntity
      );
    },
  },

  actions: {
    wsSetLanguageEntities({ commit }, payload) {
      commit('setLanguageEntities', payload);
    },
    wsLanguageEntityCreate({ commit }, payload) {
      commit('setLanguageEntityCreate', payload);
    },
    wsLanguageEntityDelete({ commit }, payload) {
      commit('setLanguageEntityDelete', payload);
    },
  },
};

export default languageEntitiesModule;
